import RepresentacaoConjunto from '@/spa/representacao-conjunto/RepresentacaoConjuntoCadastro';
import RepresentacaoConjuntoList from '@/spa/representacao-conjunto/RepresentacaoConjuntoList';
import RepresentacaoConjuntoForm from '@/spa/representacao-conjunto/RepresentacaoConjuntoForm';

export default {
  path: 'representacao-conjunto',
  component: RepresentacaoConjunto,
  children: [
    {
      path: '',
      name: 'representacao-conjunto',
      component: RepresentacaoConjuntoList,
    },
    {
      path: ':id/editar',
      name: 'editarRepresentacaoConjunto',
      component: RepresentacaoConjuntoForm,
      props: {
        somenteLeitura: false,
      },
    },
    {
      path: 'novo',
      name: 'novoRepresentacaoConjunto',
      component: RepresentacaoConjuntoForm,
    },
    {
      path: ':id',
      name: 'verRepresentacaoConjunto',
      component: RepresentacaoConjuntoForm,
      props: {
        somenteLeitura: true,
      },
    },
  ],
};
